<template>
  <div class="header">
    <router-link :to="{ name: 'index' }">{{ $t("home.home") }}</router-link>
    <router-link to="/search">{{ $t("search.search") }}</router-link>
    <a href="https://blog.wangdu.site/search/efficient-search.html" target="_blank">{{ $t("search.skill") }}</a>
    <router-link to="/chatgpt">ChatGPT</router-link>
    <router-link :to="{ name: 'comments' }">{{ $t("comments.comments") }}</router-link>
  </div>
</template>
<script>
export default {
  name: "NavBar",
};
</script>
<style scoped>
.header {
  color: #333;
  line-height: 30px;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
}
.header a{
  padding: 2px 8px;
  text-decoration: none;
  color: #333;
}
.router-link-active{
  border-bottom: cornflowerblue 1px solid;
}
</style>


// WEBPACK FOOTER //
// src/components/common/navbar/NavBar.vue